// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadWarehouses from "@insite/client-framework/Store/Components/FindLocationModal/Handlers/LoadWarehouses";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getWarehousesDataView } from "@insite/client-framework/Store/Data/Warehouses/WarehousesSelectors";
import setReturnNotes from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SetReturnNotes";
import translate from "@insite/client-framework/Translate";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Select from "@insite/mobius/Select";
import { TextAreaProps } from "@insite/mobius/TextArea";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import setRmaWarehouse from "@store/Framework/Store/Store/Pages/RequestRma/Handlers/SetRmaWarehouse";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        returnNotes: state.pages.requestRma.returnNotes,
        warehouse: state.store.pages.requestRma.warehouse,
        warehousesDataView: getWarehousesDataView(state, state.components.findLocationModal.getWarehousesParameter),
        canSendReturnRequest: state.pages.requestRma.canSendReturnRequest,
    };
};

const mapDispatchToProps = {
    setReturnNotes,
    setRmaWarehouse,
    loadWarehouses,
};

export interface RequestRmaWarehousesStyles {
    wrapper?: InjectableCss;
    notesTextArea?: TextAreaProps;
}

export const notesStyles: RequestRmaWarehousesStyles = {
    wrapper: {
        css: css`
            padding-bottom: ${pxToRem(20)};
        `,
    },
};

const styles = notesStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const RequestRmaWarehouses: FC<Props> = ({
    warehouse,
    setRmaWarehouse,
    loadWarehouses,
    warehousesDataView,
    canSendReturnRequest,
}) => {
    let selectVal = warehouse || "";
    const { value: order } = useContext(OrderStateContext);

    React.useEffect(() => {
        if (!warehousesDataView.value && !warehousesDataView.isLoading) {
            const defaultLat = constants.geolocation.defaultLat;
            const defaultLong = constants.geolocation.defaultLong;
            loadWarehouses({
                search: "",
                latitude: defaultLat,
                longitude: defaultLong,
                radius: 0,
                sort: "Distance",
            });
        }
    }, []);

    if (!order) {
        return null;
    }

    const handleSelectChange = (event: React.FormEvent<HTMLSelectElement>) => {
        if (event.currentTarget.value) {
            setRmaWarehouse({ warehouse: event.currentTarget.value });
        } else {
            selectVal = "";
        }
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Select
                label={translate("Return Warehouse")}
                required
                value={selectVal}
                onChange={handleSelectChange}
                error={
                    canSendReturnRequest && !warehouse && siteMessage("Field_Required", translate("Return Warehouse"))
                }
            >
                <option value="">{translate("Select a warehouse")}</option>
                {warehousesDataView?.value?.map((warehouse: WarehouseModel) => (
                    <option key={warehouse.id} value={warehouse.name}>
                        {warehouse.description}
                    </option>
                ))}
            </Select>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RequestRmaWarehouses),
    definition: {
        allowedContexts: ["RequestRmaPage"],
        group: "Return Request (RMA)",
        displayName: "Return Warehouse",
        fieldDefinitions: [],
    },
};

export default widgetModule;
